import { getHumanReadableDateTime } from '@Utils/helpers/stringHelpers';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './EntityDrawer.scss';

const EntityDrawerQcRow = (props) => {
    const { qcData } = props;

    return (
        <div className={cx(Styles.baseAttributeRow, Styles.attributeRowQc)}>
            <div className={Styles.attributeRowGeneric}>
                <div className={Styles.attributeRowDash} />
                <div className={Styles.attributeRowKey}>
                    <span>
                        {getHumanReadableDateTime(qcData.last_modified)}
                    </span>
                </div>
                <div className={Styles.attributeRowValue}>
                    <span>
                        {qcData.QC_result}
                        {qcData.QC_result === 'rework' && (
                            <>&ensp;-&ensp;{qcData.rework_reason}</>
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
};

EntityDrawerQcRow.propTypes = {
    qcData: PropTypes.any,
};
export default EntityDrawerQcRow;
